module.exports = __webpack_public_path__ + "static/media/pm.6ef3d821.svg";